import { fetcher } from "helpers/fetcher";

import { TGetStaffDriverLicenceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffDriverLicence = async (userId: string) => {
  return await fetcher<TGetStaffDriverLicenceRes, any>(
    ENDPOINT.USER.GET_STAFF_DRIVER_LICENCE,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_STAFF_DRIVER_LICENCE.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffDriverLicence = async (userId: string) => {
  return (await getStaffDriverLicence(userId)).data;
};

queryGetStaffDriverLicence._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_DRIVER_LICENCE.url,
  userId,
];
